module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', {
    staticClass: "hero hero-center hero-works-detail",
    class: {
      heroHome: _vm.heroHome
    }
  }, [((_vm.props.background_video___desktop.value) && (!this.$breakpoints.isMobile())) ? _c('div', {
    staticClass: "hero-video-mask"
  }, [_c('div', {
    staticClass: "overlay-gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-title-container"
  }, [_c('div', {
    staticClass: "container",
    class: {
      'text-center': _vm.heroHome
    }
  }, [(_vm.props.header_title) ? _c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "headline"
  }, [_c('span', {
    staticClass: "splitted",
    attrs: {
      "id": "splitWord"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.props.header_title.value) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.props.header_description) ? _c('h3', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "subheadline"
  }, [_vm._v(_vm._s(_vm.props.header_description.value))]) : _vm._e()])]), _vm._v(" "), _c('span', {
    ref: "toTop",
    staticClass: "toTop"
  })]) : _c('div', {
    staticClass: "hero-image-mask"
  }, [_c('div', {
    staticClass: "hero-title-container"
  }, [_c('div', {
    staticClass: "container",
    class: {
      'text-center': _vm.heroHome
    }
  }, [(_vm.props.header_description) ? _c('h3', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "subheadline"
  }, [_vm._v(_vm._s(_vm.props.client.value[0].name))]) : _vm._e(), _vm._v(" "), (_vm.props.header_title) ? _c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "headline"
  }, [_c('span', {
    staticClass: "splitted",
    attrs: {
      "id": "splitWord"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.props.header_title.value) + "\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), (_vm.props.background_image___desktop.value) ? void 0 : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d35b211","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero-works.vue
// module id = 1542
// module chunks = 0